import React from "react";
import { Button } from "react-bootstrap";
import classes from "./CustomButtonRedBg.module.css";

const CustomButtonRedBg = (props) => {
  return (
    <Button 
        className={classes.buttonStyle} 
        onClick={props.handleClick}>
        {props.children}
    </Button>
    );
};

export default CustomButtonRedBg;